<template>
      <b-overlay :show="showOverlay">
        <Breadcrumb/>
        <b-sidebar
            id="sidebar-right-add"
            shadow
            right
            bg-variant="white"
            backdrop
        >
          <add-workcenter
            @show-message="closeSideBarAdd"
            @refetch-data="getWorkcenters"
            :contextoList="listagemContexto"
          />
        </b-sidebar>
        <b-sidebar
            id="sidebar-right-edit"
            shadow
            right
            bg-variant="white"
            backdrop
        >
          <edit-workcenter
            :current-workcenter-id="currentWorkcenterId" 
            @show-message="closeSideBarEdit"
            @refetch-data="getWorkcenters"
            :contextoList="listagemContexto"
            :currentWorkcenter="listagemContextoEdit"
          />
        </b-sidebar>
        
        <b-card title="Lista de Centros de Trabalho">
            <div>
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button
                        variant="primary"
                        v-b-toggle.sidebar-right-add
                        >
                        <span class="text-nowrap">Novo Centro de Trabalho</span>
                        </b-button>
                    </div>
                  </b-form-group>
                </div>

                <b-table 
                  v-if="rows.length > 0"
                  :rows="rows"
                  :fields="fields"
                  :stickyHeader="false"
                  class="table-responsive"
                >

                  <template v-slot:cell(operators)="data">
                    <span v-for="operator in data.item.operators" :key="operator.guid">
                         {{operator}},
                    </span>
                  </template>

                  <template v-slot:cell(action)="data">
                    <span>
                        <b-dropdown
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                        >
                        <template v-slot:button-content>
                            <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="text-body align-middle mr-25"
                            />
                        </template>
                        <b-dropdown-item @click="setCurrentWorkcenter(data.item.id)">
                            <feather-icon
                            icon="EyeIcon"
                            class="mr-50"
                            />
                            <span>Editar</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="deleteWorkcenter(data.item.id)">
                            <feather-icon
                            icon="TrashIcon"
                            class="mr-50"
                            />
                            <span>Apagar</span>
                        </b-dropdown-item>
                        </b-dropdown>
                    </span>
                  </template>
                </b-table>

                <div class="demo-spacing-0">
                  <b-alert variant="primary" :show="(showOverlay == false && rows.length == 0) ? true : false" >
                    <div class="alert-body">
                      <span>Nenhum resultado encontrado.</span>
                    </div>
                  </b-alert>
                </div>
            </div>
        </b-card>
        <b-button hidden ref="closeAddStatus" v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-toggle.sidebar-right-add></b-button>
        <b-button hidden ref="closeEditStatus" v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-toggle.sidebar-right-edit></b-button>
      </b-overlay>
</template>

<script>
import Breadcrumb from '../../../layouts/components/Breadcrumb.vue'
import {
  BRow, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BAlert, BDropdown, BDropdownItem, BCard, BOverlay, BSidebar, VBToggle, BButton
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddWorkcenter from './AddWorkcenter.vue'
import EditWorkcenter from './EditWorkcenter.vue'
import BTable from '@core/components/b-table/BTable.vue'

export default {
  components: {
    BRow,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BCard,
    BOverlay,
    ToastificationContent,
    BSidebar,
    BButton,
    AddWorkcenter,
    EditWorkcenter,
    Breadcrumb,
    BTable
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  data() {
    return {
      currentSite: JSON.parse(localStorage.getItem('currentSite')),
      pageLength: 10,
      dir: false,
      currentWorkcenterId: '',
      fields: [
        {
          label: 'Nome',
          key: 'name',
          sortable: true
        },
        {
          label: 'Líder',
          key: 'leader',
          sortable: true
        },
        {
          label: 'Operadores',
          key: 'operators',
          sortable: true
        },
        {
          label: 'Ação',
          key: 'action',
          sortable: true,
          class:"col-sm-header"
        },
      ],
      rows: [],
      searchTerm: '',
      showOverlay: false,
      listagemContexto:[],
      listagemContextoEdit:[]

    }
  },
  methods: {
    getCurrentWorkcenterId(id){
      this.$http.get(`/api/workcenters/${id}`)
        .then((response) => { 
          this.listagemContextoEdit = response.data
        })
        setTimeout(this.openEditWorkcenter,600);
    },
    openEditWorkcenter(){
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-edit')
    },
    setCurrentWorkcenter(id){
      this.currentWorkcenterId = id
      this.listagemContextoEdit = []
      this.getCurrentWorkcenterId (id)
    },
    getWorkcenters(){
      this.$http.get(`/api/workcenters`)
        .then(res => { 
          this.rows = res.data;
          this.showOverlay = false; })
    },
    getContexto(){
      this.$http.get('/api/context/workcenters')
      .then(response =>
        this.listagemContexto = response.data
      )
    },
    closeSideBarAdd(){
      this.$refs.closeAddStatus.click()
    },
    closeSideBarEdit(){
      this.$refs.closeEditStatus.click()
    },
    deleteWorkcenter(id){
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        this.showOverlay = true;
        if (result.value) {
          this.$http.delete(`/api/workcenters/${id}`)
            .then(() => {
              this.getWorkcenters()
              this.showToast('Sucesso', 'SmileIcon', 'Centro de trabalho deletado com sucesso', 'success')
            })
            .catch((error) => {
              this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
            })
        }
        this.showOverlay = false;
      })
    },
    showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          text: text,
          variant,
        },
      })
    },
  },
  created() {
    this.showOverlay = true;
    this.getWorkcenters();
    this.getContexto()
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-good-table.scss';
@import '~@core/scss/vue/libs/vue-sweetalert.scss';

.col-sm-header{
 width: 5% !important;
}
.b-sidebar{
  width: 360px;
}
</style>
